import { render, staticRenderFns } from "./ProductSelections.vue?vue&type=template&id=da60e742"
import script from "./ProductSelections.vue?vue&type=script&lang=js"
export * from "./ProductSelections.vue?vue&type=script&lang=js"
import style0 from "./ProductSelections.vue?vue&type=style&index=0&id=da60e742&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports